import { type TypographyProps } from '@material-ui/system'

import { InfoBadgeStyled } from './styles/InfoBadgeStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'
import { type Enum } from '@ui/utils/enums'

export const InfoBadgeTypes = {
  HIGH_PRIORITY: 'highPriority',
  LOW_PRIORITY: 'lowPriority',
} as const

export type InfoBadgeType = Enum<typeof InfoBadgeTypes>

export interface IInfoBadgeProps extends Pick<TypographyProps, 'fontSize'> {
  /**
   * Unique identifier for analytics tracking.
   */
  analyticsId?: string
  type: InfoBadgeType
  text: string
  size?: 'small' | 'medium'
  'aria-label'?: string
}

export const InfoBadge = ({
  analyticsId,
  type,
  text,
  size = 'medium',
  fontSize = 14,
  'aria-label': ariaLabel,
}: IInfoBadgeProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <InfoBadgeStyled
      type={type}
      fontSize={fontSize}
      size={size}
      aria-label={ariaLabel}
      {...analyticsProps}
    >
      <span>{text}</span>
    </InfoBadgeStyled>
  )
}
